const PitchClassData = {
  0: {
    note: "C",
    vexflow: "c",
    slug: "c",
    sharp: "C",
    flat: "C",
  },
  1: {
    note: "C#",
    vexflow: "c#",
    slug: "cs",
    sharp: "C#",
    flat: "D♭",
  },
  2: {
    note: "D",
    vexflow: "d",
    slug: "d",
    sharp: "D",
    flat: "D",
  },
  3: {
    note: "E♭",
    vexflow: "eb",
    slug: "ef",
    sharp: "D#",
    flat: "E♭",
  },
  4: {
    note: "E",
    vexflow: "e",
    slug: "e",
    sharp: "E",
    flat: "E",
  },
  5: {
    note: "F",
    vexflow: "f",
    slug: "f",
    sharp: "F",
    flat: "F",
  },
  6: {
    note: "F#",
    vexflow: "f#",
    slug: "fs",
    sharp: "F#",
    flat: "G♭",
  },
  7: {
    note: "G",
    vexflow: "g",
    slug: "g",
    sharp: "G",
    flat: "G",
  },
  8: {
    note: "A♭",
    vexflow: "ab",
    slug: "af",
    sharp: "G#",
    flat: "A♭",
  },
  9: {
    note: "A",
    vexflow: "a",
    slug: "a",
    sharp: "A",
    flat: "A",
  },
  10: {
    note: "B♭",
    vexflow: "bb",
    slug: "bf",
    sharp: "A#",
    flat: "B♭",
  },
  11: {
    note: "B",
    vexflow: "b",
    slug: "b",
    sharp: "B",
    flat: "B",
  },
};

export default PitchClassData;
